import { State } from '../State';
import { getChampionsLeagueAvatarFrame } from '../championsLeague/championsLeague.getters';
import { Locale } from '../ruleset/locale';
import { GENERIC_AVATAR } from './assets';

/**
 * Get player profile, with default values if not set.
 * @param state
 * @param publicName
 * @param publicPicture
 * @param privateName - only provide for friends
 * @param privatePicture - only provide for friends
 * @returns
 */
export function getPlayerProfile(
  state: State,
  publicName: string | undefined,
  publicPicture: string | undefined,
  privateName?: string | undefined,
  privatePicture?: string | undefined,
  me?: boolean,
): { name: string; photo: string; visitable: boolean } {
  return getPlayerProfileFromLocale(
    state.settings.locale as Locale,
    publicName,
    publicPicture,
    privateName,
    privatePicture,
    me,
  );
}

/**
 * Get player profile from locale, with default values if not set.
 * @param locale
 * @param publicName
 * @param publicPicture
 * @param privateName
 * @param privatePicture
 * @returns
 */
export function getPlayerProfileFromLocale(
  locale: Locale,
  publicName: string | undefined,
  publicPicture: string | undefined,
  privateName?: string | undefined,
  privatePicture?: string | undefined,
  me?: boolean,
): { name: string; photo: string; visitable: boolean } {
  const defaultMeName = locale === 'ja' ? '自分' : 'ME';
  const defaultOthersName = locale === 'ja' ? '新規プレイヤー' : 'New Player';
  const defaultName = me ? defaultMeName : defaultOthersName;

  return {
    name: publicName || privateName || defaultName,
    photo: publicPicture || privatePicture || GENERIC_AVATAR,
    visitable: !!publicName || !!privateName,
  };
}

/**
 * Name to show for a player who has not set up a public profile.
 *
 * Distinct from the `getPlayerProfileFromLocale` fallback: that one stands in for a
 * profile we couldn't read, this one states that there is none to read.
 * @param locale
 * @returns
 */
export function getUnsetPublicProfileName(locale: Locale): string {
  return locale === 'ja' ? 'プロフィール未設定' : 'No Profile';
}

/**
 * Get currently equipped player profile avatar frame.
 */
export function getPlayerProfileAvatarFrame(
  state: State,
):
  | 'default'
  | 'league_crown'
  | 'league_master'
  | 'league_grandmaster'
  | 'league_champion' {
  // Currently, we only support the Champions League avatar frame
  return getChampionsLeagueAvatarFrame(state) ?? 'default';
}
